import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl } from 'react-intl';
import SvgIcon from '../svg-icon/svg-icon';
import css from './index.scss';
import Button from '../button/index';
import { Cross, Tick, Warning } from '../../helpers/icon-dictionary';
import { ICON_ONLY } from '../button/variants';

const ConfirmationRequest = ({ children, handleOnCancel, handleOnClose, handleOnOk, isLoading }) =>
    (<div className={css.confirmationMessageContainer}>
        <div className={css.icon}>
            <SvgIcon icon={Warning} />
        </div>
        <div className={css.message}>
            <div className={css.confirm}>
                <div>
                    {children}
                </div>
            </div>
        </div>
        <div className={css.container}>
            <Button
                buttonContainer={css.cancel}
                buttonContainerDisabled={css.cancelButtonDisabled}
                disabled={isLoading}
                handleOnClick={handleOnCancel}
                icon={Cross}
                iconClassName={css.iconClassName}
                loading={isLoading} />
            <Button
                buttonContainer={css.ok}
                buttonContainerDisabled={css.okButtonDisabled}
                disabled={isLoading}
                handleOnClick={handleOnOk}
                icon={Tick}
                iconClassName={css.iconClassName}
                loading={isLoading} />
        </div>
        <Button
            containerClassName={css.buttonClose}
            disabled={isLoading}
            handleOnClick={handleOnClose}
            icon={Cross}
            variant={ICON_ONLY} />
    </div>);

ConfirmationRequest.propTypes = {
    children: PropTypes.node,
    handleOnClose: PropTypes.func,
    handleOnOk: PropTypes.func,
    handleOnCancel: PropTypes.func,
    isLoading: PropTypes.bool
};

export default injectIntl(styleable(css)(ConfirmationRequest));



// WEBPACK FOOTER //
// ./app/components/confirmation-request/index.js